import { render } from "./ProspectsManager.vue?vue&type=template&id=385d8512&scoped=true"
import script from "./ProspectsManager.vue?vue&type=script&lang=js"
export * from "./ProspectsManager.vue?vue&type=script&lang=js"

import "./ProspectsManager.vue?vue&type=style&index=0&id=385d8512&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-385d8512"]])

export default __exports__